import styles from "../../FirewallEdit.module.scss";
import TabPageHeader from "./TabPageHeader";
import { useGetFirewallByIdQuery } from "../../../../redux/services/firewalls-service";
import GeneralInfoOverview from "./OverviewComponents/GeneralInfoOverview";
import SecurityPoliciesOverview from "./OverviewComponents/SecurityPoliciesOverview";
import EgressNatOverview from "./OverviewComponents/EgressNatOverview";
import UserIdOverview from "./OverviewComponents/UserIdOverview";
import EndpointsOverview from "./OverviewComponents/EndpointsOverview";
import LogsMetricsOverview from "./OverviewComponents/LogsMetricsOverview";
import { useTranslate } from "../../../../customHooks";
import { toast } from "../../../../components";
import { LoadingPanel } from "@panwds/react-ui";

interface OverviewFirewallProps {
    fwid: string;
    region: string;
}


const FirewallOverview= (props: {firewallData: Record<string, any>, isLoading: boolean, refreshFirewallData: () => void, handleTabChange: (tabId: string) => void, featureFlags: Record<string, any> }) => {
    const translate = useTranslate();
    const { firewallData, isLoading, refreshFirewallData, handleTabChange, featureFlags } = props;
    const firewall = firewallData?.Firewall;
    const status = firewallData?.Status;

    // Determine the managed by value
    let managedBy = "Default Rulestack";
    if (firewall?.RuleStackName) {
        managedBy = "Local Rulestack";
    } else if (firewall?.LinkId) {
        managedBy = firewall.LinkId.includes("Link-SCM") ? "SCM" : "Panorama";
    }

    return (
        <div className={`tw-relative ${styles.overviewFirewallContainer}`}>
            {props?.isLoading &&
                <div className="tw-absolute tw-inset-0 tw-right-0 tw-flex tw-justify-center tw-items-center tw-backdrop-blur-sm tw-z-50" style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)' }}>
                    <div className="tw-w-6 tw-h-6">
                        <LoadingPanel />
                    </div>
                </div>
            }
            <TabPageHeader title={translate(`resources.firewallsV2.overview`)} />
            <div className={styles.overviewFirewallSubContainer}>
                <div className={styles.halfWidth}>
                    <GeneralInfoOverview firewall={firewall} status={status} styles={styles} />
                </div>
                <div className={styles.halfWidth}>
                    <SecurityPoliciesOverview firewall={firewall} status={status} managedBy={managedBy} styles={styles} />
                </div>
            </div>
            <div className={styles.overviewFirewallSubContainer}>
                <div className={styles.halfWidth}>
                    <EgressNatOverview firewall={firewall} status={status} styles={styles} />
                </div>
                {featureFlags?.UserID === true && (
                <div className={styles.halfWidth}>
                    <UserIdOverview firewall={firewall} styles={styles} />
                </div>
                )}
            </div>
            <div className={styles.overviewFirewallSubContainer}>
                <div className={styles.halfWidth}>
                    <EndpointsOverview firewall={firewall} styles={styles} handleTabChange={() => handleTabChange('endpoints')} />
                </div>
                <div className={styles.halfWidth}>
                    <LogsMetricsOverview firewall={firewall} styles={styles} />
                </div>
            </div>
        </div>
    );
};

export default FirewallOverview;
